import type { LocationOption } from "../api/locations";
import { t } from "../lib/i18n";

/**
 * 拠点一覧を Select の選択肢へ落とす（5画面共通）。
 *
 * 🔴 backend（/api/locations）は**プランの拠点数上限を超えた拠点も返す**。
 * 隠すと「なぜ2拠点目が選べないのか」を画面が説明できないから＝設計意図として
 * `allowed=false` を付けて返している。SPA 側がこのフラグを読まずに全件を
 * そのまま選択肢にしていたため、超過拠点を選んだ瞬間に 403 が汎用の
 * 「サーバーへの接続に失敗しました…再試行」として出ていた（理由が伝わらない）。
 * ここで disabled にし、理由をラベルに書く。
 *
 * `allowed` が無いのは SPA が backend より先に出たデプロイスキューの間だけ＝
 * 従来どおり選択可として扱う。
 */
export function toLocationSelectOptions(
  locations: LocationOption[],
): { label: string; value: string; disabled: boolean }[] {
  return locations.map((location) => {
    const allowed = location.allowed !== false;
    return {
      label: allowed
        ? location.name
        : t("{name}（プランの拠点数上限を超えています）", { name: location.name }),
      value: String(location.id),
      disabled: !allowed,
    };
  });
}
